import React from 'react';
import { hashClass } from '../../../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../../../context';
const ProgressRadialItem = ({ color, className }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx(`progress-circle-slice progress-circle-background-${color}`, className));
    return React.createElement("div", { className: classes });
};
export default ProgressRadialItem;
//# sourceMappingURL=ProgressRadialtem.js.map